import "core-js/actual/regexp/escape";
import "core-js/actual/iterator/take";
import "core-js/actual/iterator/to-array";
import "core-js/actual/iterator/filter";
import "core-js/actual/iterator/map";
import "core-js/actual/array/to-sorted";
import "core-js/actual/map/group-by";

globalThis.global = globalThis;
